module.exports = __webpack_public_path__ + "static/img/pinJie1.e00f51c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pinJie1.png
// module id = BSww
// module chunks = 2